import React from "react";
import type { Properties } from "./properties";
import { WizardView } from "./wizard-view";

export const Wizard = (props: Properties) => {
	return (
		<WizardView
			{...props}
			step={props.step !== undefined && props.step >= 0 ? props.step : 0}
		/>
	);
};
